import Vue from 'vue'
import Router from 'vue-router'
import Controller from '@/router/controller'
import NaoExiste from '@/components/pages/paginas-informativas/NaoExiste'
import AcessoNegado from '@/components/pages/paginas-informativas/AcessoNegado'
import Login from '@/components/pages/login/Login'
import EsqueciSenha from '@/components/pages/login/EsqueciSenha'
import RecuperarSenha from '@/components/pages/login/RecuperarSenha'
import CadastrarSenha from '@/components/pages/login/CadastrarSenha'
import Questionario from '@/components/pages/questionario/Questionario'
import QuestionarioFinalizado from '@/components/pages/questionario/QuestionarioFinalizado'
import ListagemSolicitacoes from '@/components/pages/listagem-solicitacoes/ListagemSolicitacoes'
import SolicitacaoConsulta from '@/components/pages/solicitacao-consulta/SolicitacaoConsulta'
import GestaoUsuarios from '@/components/pages/usuarios/GestaoUsuarios'
import CadastroUsuario from '@/components/pages/usuarios/CadastroUsuario'
import GestaoGrupos from '@/components/pages/grupo-usuarios/GestaoGrupos'
import CadastroGrupos from '@/components/pages/grupo-usuarios/CadastroGrupos'
import GestaoPerfil from '@/components/pages/perfil/GestaoPerfil'
import CadastroPerfil from '@/components/pages/perfil/CadastroPerfil'
import Auditoria from '@/components/pages/auditoria/Auditoria'
import Dashboard from '@/components/pages/dashboard/Dashboard'
import GestaoClientes from '@/components/pages/gestao-clientes/GestaoClientes'
import GridPrincipal from '@/components/pages/frota/GridPrincipal'
import InfoGerais from '@/components/pages/frota/InfoGerais'
import Risco from '@/components/pages/frota/Risco'
import GridVeiculos from '@/components/pages/frota/GridVeiculos'
import Cobertura from '@/components/pages/frota/Cobertura';
import InfoEndosso from '@/components/pages/frota/InfoEndosso';
import GridEndossoVeiculos from '@/components/pages/frota/GridEndossoVeiculos'
import CoberturaEndosso from '@/components/pages/frota/CoberturaEndosso';
import GridEndossos from '@/components/pages/frota/GridEndossos';
import GridEndossoVeiculoExclusao from '@/components/pages/frota/GridEndossoVeiculoExclusao';
import CoberturaEndossoExclusao from '@/components/pages/frota/CoberturaEndossoExclusao';
import GridEndossoVeiculoSubstituicao from '@/components/pages/frota/GridEndossoVeiculoSubstituicao';
import GridEndossoVeiculosAlteracao from '@/components/pages/frota/GridEndossoVeiculosAlteracao';
import CoberturaEndossoSubstituicao from '@/components/pages/frota/CoberturaEndossoSubstituicao';
import QuestionarioAnaliseRiscos  from '@/components/pages/questionario-analise-riscos/QuestionarioAnaliseRiscos'
import GridCadastroVeiculos from '@/components/pages/cadastro-veiculos/GridCadastroVeiculos';
import InfoVeiculos from '@/components/pages/cadastro-veiculos/InfoVeiculos';
import GridSolicitacaoCotacao from '@/components/pages/corretor-reserva/GridSolicitacaoCotacao';
import GridConsultaItens from '@/components/pages/consulta-itens/GridConsultaItens';
import GridRelatorioProdutividade from '@/components/pages/tela-relatorio-produtividade/GridRelatorioProdutividade';
import GridClassificacaoCotacoes from '@/components/pages/classificacao-cotacoes/GridClassificacaoCotacoes';
import GestaoTaxasSeguro from '@/components/pages/gestao-taxas/GestaoTaxasSeguro';
import GridEndossoCorretor from '@/components/pages/corretor-reserva/GridEndossoCorretor'
import InfoEndossoCorretor from '@/components/pages/corretor-reserva/InfoEndossoCorretor'
import GridEndossoVeiculosCorretor from '@/components/pages/corretor-reserva/GridEndossoVeiculosCorretor'
import CoberturaEndossoCorretor from '@/components/pages/corretor-reserva/CoberturaEndossoCorretor';
import GridEndossoVeiculoExclusaoCorretor from '@/components/pages/corretor-reserva/GridEndossoVeiculoExclusaoCorretor';
import CoberturaEndossoExclusaoCorretor from '@/components/pages/corretor-reserva/CoberturaEndossoExclusaoCorretor';
import GridEndossoVeiculoSubstituicaoCorretor from '../components/pages/corretor-reserva/GridEndossoVeiculoSubstituicaoCorretor.vue'
import CoberturaEndossoSubstituicaoCorretor from '../components/pages/corretor-reserva/CoberturaEndossoSubstituicaoCorretor.vue'

Vue.use(Router)

const roteador = new Router({
  routes: [
    {
      path: '/corretor/coberturas',
      name: 'CoberturaEndossoCorretor',
      meta: { permissao: 29, title: 'Coberturas Corretor', navbartitle: 'Coberturas', requiresAuth: true, plataforma: 2 },
      component: CoberturaEndossoCorretor
    },
    {
      path: '/corretor/gridCoberturasSubstituicaoCorretor',
      name: 'CoberturaEndossoSubstituicaoCorretor',
      meta: { permissao: 29, title: 'Coberturas Corretor', navbartitle: 'Coberturas', requiresAuth: true, plataforma: 2 },
      component: CoberturaEndossoSubstituicaoCorretor
    },
    {
      path: '/corretor/gridVeiculosExclusao',
      name: 'GridEndossoVeiculoExclusaoCorretor',
      meta: { permissao: 29, title: 'Grid Veiculos Exclusão', navbartitle: 'Grid Veículos', requiresAuth: true, plataforma: 2 },
      component: GridEndossoVeiculoExclusaoCorretor
    },
    {
      path: '/corretor/gridCoberturasExclusaoCorretor',
      name: 'CoberturaEndossoExclusaoCorretor',
      meta: { permissao: 29, title: 'Grid Cobertura Exclusão', navbartitle: 'Grid Coberturas', requiresAuth: true, plataforma: 2 },
      component: CoberturaEndossoExclusaoCorretor
    },
    {
      path: '/corretor/gridEndossoVeiculoSubstituicaoCorretor',
      name: 'GridEndossoVeiculoSubstituicaoCorretor',
      meta: { permissao: 29, title: 'Coberturas Corretor', navbartitle: 'Coberturas', requiresAuth: true, plataforma: 2 },
      component: GridEndossoVeiculoSubstituicaoCorretor
    },
    {
      path: '/corretor/gridVeiculos',
      name: 'InfoEndossoCorretor',
      meta: { permissao: 29, title: 'Grid com informações de veiculos', navbartitle: 'Grid Veículos', requiresAuth: true, plataforma: 2 },
      component: GridEndossoVeiculosCorretor
    },
    {
      path: '/corretor/InfoEndosso',
      name: 'InfoEndossoCorretor',
      meta: { permissao: 29, title: 'Informações Endosso', navbartitle: 'Informações Endosso', requiresAuth: true, plataforma: 2 },
      component: InfoEndossoCorretor
    },
    {
      path: '/corretor/endossos',
      name: 'GridEndossoCorretor',
      meta: { permissao: 29, title: 'Grid Endossos Corretor', navbartitle: 'Grid Endossos', requiresAuth: true, props: true, plataforma: 2},
      component: GridEndossoCorretor,
    },
    {
      path: '/GridClassificacaoCotacoes',
      name: 'GridClassificacaoCotacoes',
      meta: { permissao: 17, title: 'Grid Classificações de cotações', navbartitle: 'Classificações de cotações', requiresAuth: true, props: true, plataforma: 2},
      component: GridClassificacaoCotacoes,
    },
    {
      path: '/GestaoTaxasSeguro',
      name: 'GestaoTaxasSeguro',
      meta: { permissao: 36, flagUsuario: 'gestaoTaxasSeguro', title: 'Gestão de Taxas de Seguro', navbartitle: 'Gestão de Taxas', requiresAuth: true, props: true, plataforma: 2},
      component: GestaoTaxasSeguro,
    },
    {
      path: '/GridRelatorioProdutividade',
      name: 'GridRelatorioProdutividade',
      meta: { permissao: 5, title: 'Grid Relatorio Produtividade', navbartitle: 'Relatório Produtividade', requiresAuth: true, props: true, plataforma: 2},
      component: GridRelatorioProdutividade,
    },
    {
      path: '/GridConsultaItens',
      name: 'GridConsultaItens',
      meta: { permissao: 16, title: 'Grid Consulta de Itens', navbartitle: 'Consulta Itens', requiresAuth: true, props: true},
      component: GridConsultaItens,
    },
    {
      path: '/QuestionarioAnaliseRiscos',
      name: 'QuestionarioAnaliseRiscos',
      meta: { permissao: 2, title: 'Questionario de analise de riscos', navbartitle: 'QAR', requiresAuth: true, props: true},
      component: QuestionarioAnaliseRiscos,
    },
    {
      path: '/GridCadastroVeiculos/InfoVeiculos',
      name: 'InfoVeiculos',
      meta: { permissao: 14, title: 'Informações cadastro de veículos', navbartitle: 'Informações cadastro de veículos', requiresAuth: true, plataforma: 2 },
      component: InfoVeiculos
    },
    {
      path: '/GridCadastroVeiculos',
      name: 'GridCadastroVeiculos',
      meta: { permissao: 14, title: 'Cadastro de Veículos', navbartitle: 'Cadastro de Veículos', requiresAuth: true, props: true, plataforma: 2},
      component: GridCadastroVeiculos
    },
    {
      path: '/Questionario',
      name: 'Questionario',
      meta: { permissao: 2, title: 'Questionário', navbartitle: 'Questionário de Análise de Riscos', requiresAuth: false, props: true},
      component: Questionario
    },
    {
      path: '/QuestionarioFinalizado',
      name: 'QuestionarioFinalizado',
      meta: { permissao: 2, title: 'Questionário Finalizado', navbartitle: 'Questionário Finalizado', requiresAuth: false, plataforma: 1 },
      component: QuestionarioFinalizado
    },
    {
      path: '/GridSolicitacaoCotacao',
      name: 'GridSolicitacaoCotacao',
      meta: { permissao: 29, title: 'Listagem de Cotações', navbartitle: 'Listagem de Cotações', requiresAuth: true, plataforma: 2 },
      component: GridSolicitacaoCotacao
    },
    {
      path: '/ListagemSolicitacoes',
      name: 'ListagemSolicitacoes',
      meta: { permissao: 8, title: 'Listagem de Solicitações', navbartitle: 'Listagem de Solicitações', requiresAuth: true, plataforma: 1 },
      component: ListagemSolicitacoes
    },
    {
      path: '/Solicitacao/:id',
      name: 'SolicitacaoConsulta',
      meta: { permissao: 8, title: 'Solicitação', navbartitle: 'Consulta de Solicitação', requiresAuth: true, plataforma: 1 },
      component: SolicitacaoConsulta
    },
    {
      path: '/Dashboard',
      name: 'Dashboard',
      meta: { permissao: 3, title: 'Dashboard', navbartitle: 'Dashboard', requiresAuth: true, plataforma: 1 },
      component: Dashboard
    },
    {
      path: '/Auditoria',
      name: 'Auditoria',
      meta: { permissao: 1, title: 'Auditoria', navbartitle: 'Auditoria', requiresAuth: true, plataforma: 1 },
      component: Auditoria
    },
    {
      path: '/GestaoClientes',
      name: 'GestaoClientes',
      meta: { permissao: 13, title: 'Gestão de Clientes', navbartitle: 'Gestão de Clientes', requiresAuth: true, plataforma: 1 },
      component: GestaoClientes
    },
    {
      path: '/GestaoGrupos',
      name: 'GestaoGrupos',
      meta: { permissao: 7, title: 'Gestão de Grupos', navbartitle: 'Gestão de Grupos', requiresAuth: true, plataforma: 1, },
      component: GestaoGrupos
    },
    {
      path: '/GestaoGrupos/Cadastro/:id?',
      name: 'CadastroGrupos',
      meta: { permissao: 7, title: 'Cadastro de Grupo', navbartitle: 'Cadastro de Grupo', requiresAuth: true, plataforma: 1 },
      component: CadastroGrupos
    },
    {
      path: '/GestaoUsuarios',
      name: 'GestaoUsuarios',
      meta: { permissao: 6, title: 'Gestão de Usuários', navbartitle: 'Gestao de Usuários', requiresAuth: true, plataforma: 1 },
      component: GestaoUsuarios
    },
    {
      path: '/GestaoUsuarios/CadastroUsuario/:id?',
      name: 'CadastroUsuario',
      meta: { permissao: 6, title: 'Cadastro de Usuário', navbartitle: 'Cadastro de Usuário', requiresAuth: true, plataforma: 1 },
      component: CadastroUsuario
    },
    {
      path: '/GestaoPerfil',
      name: 'GestaoPerfil',
      meta: { permissao: 5, title: 'Gestão de Perfil', navbartitle: 'Gestão de Perfil', requiresAuth: true, plataforma: 1 },
      component: GestaoPerfil
    }, {
      path: '/GestaoPerfil/Cadastro/:id?',
      name: 'CadastroPerfil',
      meta: { permissao: 5, title: 'Cadastro de Perfil', navbartitle: 'Cadastro de Perfil', requiresAuth: true, plataforma: 1 },
      component: CadastroPerfil
    },
    {
      path: '/GridPrincipal/InfoEndosso',
      name: 'InfoEndosso',
      meta: { permissao: 5, title: 'Informações Endosso', navbartitle: 'Informações Endosso', requiresAuth: true, plataforma: 2 },
      component: InfoEndosso
    },
    {
      path: '/GridPrincipal',
      name: 'GridPrincipal',
      meta: { permissao: 5, title: 'Grid Principal', navbartitle: 'Grid Pricipal', requiresAuth: true, plataforma: 2 },
      component: GridPrincipal
    },
    {
      path: '/GridPrincipal/InfoGerais',
      name: 'InfoGerais',
      meta: { permissao: 5, title: 'Informações Gerais', navbartitle: 'Informações Gerais', requiresAuth: true, plataforma: 2 },
      component: InfoGerais
    },
    {
      path: '/GridPrincipal/Risco',
      name: 'Risco',
      meta: { permissao: 5, title: 'Risco', navbartitle: 'Risco', requiresAuth: true, plataforma: 2 },
      component: Risco
    },
    {
      path: '/GridPrincipal/GridVeiculos',
      name: 'GridVeiculos',
      meta: { permissao: 5, title: 'GridVeiculos', navbartitle: 'GridVeiculos', requiresAuth: true, plataforma: 2 },
      component: GridVeiculos
    },
    {
      path: '/GridPrincipal/GridEndossoVeiculos',
      name: 'GridEndossoVeiculos',
      meta: { permissao: 5, title: 'GridEndossoVeiculos', navbartitle: 'GridEndossoVeiculos', requiresAuth: true, plataforma: 2 },
      component: GridEndossoVeiculos
    },
    {
      path: '/GridPrincipal/GridEndossoVeiculoExclusao',
      name: 'GridEndossoVeiculoExclusao',
      meta: { permissao: 5, title: 'GridEndossoVeiculoExclusao', navbartitle: 'GridEndossoVeiculoExclusao', requiresAuth: true, plataforma: 2 },
      component: GridEndossoVeiculoExclusao
    },
    {
      path: '/GridPrincipal/CoberturaEndossoExclusao',
      name: 'CoberturaEndossoExclusao',
      meta: { permissao: 5, title: 'CoberturaEndossoExclusao', navbartitle: 'CoberturaEndossoExclusao', requiresAuth: true, plataforma: 2 },
      component: CoberturaEndossoExclusao
    },
    {
      path: '/GridPrincipal/GridEndossoVeiculoSubstituicao',
      name: 'GridEndossoVeiculoSubstituicao',
      meta: { permissao: 5, title: 'GridEndossoVeiculoSubstituicao', navbartitle: 'GridEndossoVeiculoSubstituicao', requiresAuth: true, plataforma: 2 },
      component: GridEndossoVeiculoSubstituicao
    },
    {
      path: '/GridPrincipal/GridEndossoVeiculosAlteracao',
      name: 'GridEndossoVeiculosAlteracao',
      meta: { permissao: 5, title: 'GridEndossoVeiculosAlteracao', navbartitle: 'GridEndossoVeiculosAlteracao', requiresAuth: true, plataforma: 2 },
      component: GridEndossoVeiculosAlteracao
    },
    {
      path: '/GridPrincipal/CoberturaEndossoSubstituicao',
      name: 'CoberturaEndossoSubstituicao',
      meta: { permissao: 5, title: 'CoberturaEndossoSubstituicao', navbartitle: 'CoberturaEndossoSubstituicao', requiresAuth: true, plataforma: 2 },
      component: CoberturaEndossoSubstituicao
    },
    {
      path: '/GridPrincipal/CoberturaEndosso',
      name: 'CoberturaEndosso',
      meta: { permissao: 5, title: 'CoberturaEndosso', navbartitle: 'CoberturaEndosso', requiresAuth: true, plataforma: 2 },
      component: CoberturaEndosso
    },
    {
      path: '/GridPrincipal/InfoGerais/GridEndossos',
      name: 'GridEndossos',
      meta: { permissao: 5, title: 'GridEndossos', navbartitle: 'GridEndossos', requiresAuth: true, plataforma: 2 },
      component: GridEndossos
    },
    {
      path: '/GridPrincipal/Cobertura',
      name: 'Cobertura',
      meta: { permissao: 5, title: 'Cobertura', navbartitle: 'Cobertura', requiresAuth: true, plataforma: 2 },
      component: Cobertura
    },
    {
      path: '/Login',
      name: 'Login',
      meta: { title: 'Login', navbartitle: 'Login', requiresAuth: false, hideLogin: true },
      component: Login
    },
    {
      path: '/RecuperarSenha/:token',
      name: 'RecuperarSenha',
      meta: { title: 'Recuperação de Senha', navbartitle: 'Recuperação de Senha', requiresAuth: false, hideLogin: true },
      component: RecuperarSenha
    },
    {
      path: '/CadastrarSenha/:token',
      name: 'CadastrarSenha',
      meta: { title: 'Cadastro de Senha', navbartitle: 'Cadastro de Senha', requiresAuth: false, hideLogin: true },
      component: CadastrarSenha
    },
    {
      path: '/EsqueciSenha',
      name: 'EsqueciSenha',
      meta: { title: 'Recuperação de Senha', navbartitle: 'Recuperação de Senha', requiresAuth: false, hideLogin: true },
      component: EsqueciSenha
    },
    {
      path: '/AcessoNegado',
      name: 'AcessoNegado',
      meta: { title: 'Acesso Negado', requiresAuth: false },
      component: AcessoNegado
    },
    {
      path: '*',
      name: 'NaoExiste', //Esta pagina tem um método que redireciona quando o path for '/'
      meta: { title: 'Página Não Existe', requiresAuth: false },
      component: NaoExiste
    }
  ],
  mode: 'history'
});

roteador.beforeEach((to, from, next) => {
  Controller.processarMudancaTela(to, from, next);
});

export default roteador;



// WEBPACK FOOTER //
// ./src/router/index.js